module.exports = __webpack_public_path__ + "static/img/ability-icon4.9275765.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/ability-icon4.png
// module id = t/1B
// module chunks = 1